import { render, staticRenderFns } from "./AutoInvestFaq.vue?vue&type=template&id=2932472b&scoped=true&"
import script from "./AutoInvestFaq.vue?vue&type=script&lang=js&"
export * from "./AutoInvestFaq.vue?vue&type=script&lang=js&"
import style0 from "./AutoInvestFaq.vue?vue&type=style&index=0&id=2932472b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932472b",
  null
  
)

export default component.exports